import { Component, OnInit, ViewChild } from '@angular/core';
import { MatAutocompleteSelectedEvent, MatDatepickerInputEvent, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { ClientOrderService } from './clientorderreport.service';
import * as moment from 'moment';
import { UserService } from '../services/user.service';
import { TableUtil } from '../admintrademaster/tableUtil';
// import * as moment from 'moment-timezone';
@Component({
    selector: 'app-clientorderreport',
    templateUrl: './clientorderreport.component.html',
    styleUrls: ['./clientorderreport.component.css']
})
export class ClientOrderReportComponent implements OnInit {
    displayedColumns = [
        'OrderTS',
        'Pair',
        'Side',
        'OrderType',
        'OrderSource',
        'Client',
        'UserEmail',
        'OrderId',
        'ClientOrderId',
        'Quantity',
        'Price',
        'OrderStatus',
        'AvgFillPrice',
        'FillQuantity',
        'Country',
        'WalletType',
        'CommentText'
    ];
    dataSource: MatTableDataSource<ClientOrderData>;
    pageSize = 25;
    users;
    clients: any[] = [];
    clientListSearchCopy: any[] = [];
    selectedClientValue: boolean = true;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    fromDate;
    toDate;
    filter: any = {};
    // csrf: any;
    public selectedDate = new Date();
    public selectedDate1 = new Date();

    constructor(private clientOrderSer: ClientOrderService, private userService: UserService) { }

    ngOnInit() {
        this.filteredData();
        this.getClients();
        const fDate = Date.UTC(this.selectedDate.getFullYear(), this.selectedDate.getMonth(), this.selectedDate.getDate());
        const tDate = Date.UTC(this.selectedDate1.getFullYear(), this.selectedDate1.getMonth(), this.selectedDate1.getDate()) + 86400000; // add one day's worth of milliseconds
        this.filter['fDate'] = fDate;
        this.filter['tDate'] = tDate;


    }
    fromDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.fromDate = moment(event.value).valueOf();
        this.filter['fDate'] = this.fromDate;
    }
    toDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.toDate = moment(event.value).valueOf();
        this.filter['tDate'] = this.toDate;
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }
    getClients() {
        this.userService.getClients().subscribe(clients => {
            this.users = clients
            clients = clients.map(function (item) {
                return { clientName: item.name };
            })
            this.clients = clients.map(list => list.clientName)
                .filter((value, index, self) => self.indexOf(value) === index).sort((a, b) => a > b ? 1 : -1);
            this.clientListSearchCopy = this.clients;
        })
    }
    filterWithClient(event: any) {
        let term = event;
        this.clients = this.clientListSearchCopy.filter(function (tag) {
            if (tag.toLowerCase().indexOf(term.toLowerCase()) >= 0 || tag.toLowerCase().indexOf(term.toLowerCase()) >= 0) {
                return tag;
            }
        });
    }
    onOptionSelected(event: MatAutocompleteSelectedEvent) {
        this.selectedClientValue = false;
        const selectedValue = event.option.value;
        const result = this.users.find(user => user.name === selectedValue);
        if (result) this.filter['UserId'] = result._id;
    }
    async filteredData() {
        this.userService.csrf().subscribe(async success => {
            this.filter["_csrf"] = success._csrf;
            await this.clientOrderSer.getOrdersWithFilter(this.filter).subscribe(async orders => {
                if (orders.data) {
                    let dateRes = await orders.data.map((order => {
                        order.OrderTS = moment(order.OrderTS).format('MM/DD/YY h:mm:ss A')
                        if (order.OrderType === 'MARKET') {
                            order.Price = ''
                        }
                        return order;
                    }))
                    this.dataSource = new MatTableDataSource(dateRes);
                    this.dataSource.paginator = this.paginator;
                    this.dataSource.sort = this.sort;
                }
            })
        })
    }
    applyFilterDate() {
        this.filteredData();
    }
    exportArray() {
        if (this.dataSource.filteredData) {
            const ClientOrderArr = this.dataSource.filteredData.map(x => ({
                OrderTS: x.OrderTS,
                Pair: x.Pair,
                Side: x.Side,
                OrderType: x.OrderType,
                OrderSource: x.OrderSource,
                Client: x.Client,
                UserEmail: x.UserEmail,
                OrderId: x.OrderId,
                ClientOrderId: x.ClientOrderId,
                Quantity: x.Quantity,
                Price: x.Price,
                OrderStatus: x.OrderStatus,
                TradePrice: x.TradePrice,
                TradeQuantity: x.TradeQuantity,
                Country: x.Country,
                WalletType: x.WalletType,
                CommentText: x.CommentText
            }));
            TableUtil.exportArrayToExcel(ClientOrderArr, "ClientOrderArr");
        }

    }

}

export interface ClientOrderData {
    OrderTS: string,
    Pair: string,
    Side: string,
    OrderType: string,
    OrderSource: string,
    Client: string,
    UserEmail: string,
    OrderId: string,
    ClientOrderId: string,
    Quantity: number,
    Price: number,
    OrderStatus: string,
    TradePrice: number,
    TradeQuantity: number,
    Country: string,
    WalletType: String
    CommentText: string,

}



// WEBPACK FOOTER //
// ./src/app/clientorderreport/clientorderreport.component.ts